module.exports = __webpack_public_path__ + "img/logo_gris.d2d934fa.svg";